import input from "src/components/atoms/input/input";
import { ApiService } from "src/network/apiService";
import { IContactCentreModel } from "src/types/models/apiModels";

export class NewContactCentreViewModel {
  private apiService: ApiService;

  constructor(accessToken: string) {
    this.apiService = new ApiService({ accessToken: accessToken });
  }

  async validateContactCentre(
    contactCentre: IContactCentreModel
  ): Promise<string[]> {
    const errors: string[] = [];
    if (!contactCentre.name) {
      errors.push("name is required");
    }
    if (contactCentre.allowedUrls.length === 0) {
      errors.push("Please add at least one allowed url");
    }

    if (contactCentre.eventDeliveryMethod === "WEBHOOK") {
      const webhookUrl = contactCentre.webhookConfig?.webhookUrl;

      if (!webhookUrl) {
        errors.push("Webhook URL is required");
      } else {
        try {
          const parsedUrl = new URL(webhookUrl);
          if (!["http:", "https:"].includes(parsedUrl.protocol)) {
            errors.push("Webhook URL must start with http or https");
          }
        } catch {
          errors.push("Webhook URL is invalid");
        }
      }
    }

    if (contactCentre.allowedUrls.length > 0 && contactCentre.allowedUrls[0] !== "") {
      contactCentre.allowedUrls.forEach((url: string) => {
        try {
          new URL(url); // this will throw if invalid
        } catch {
          errors.push(`Invalid URL: ${url}`);
        }
      });
    } else {
      errors.push("Please add at least one allowed url");
    }

    return errors;
  }

  async saveContactCentre(
    contactCentre: IContactCentreModel
  ): Promise<{ result: boolean; error?: string }> {

    try {
      console.log("input", contactCentre);
      const response: any = await this.apiService.postAsync(
        "/onboard/contact-centre",
        contactCentre
      );

      if (response) {
        if (response.scResponse && response.scResponse.code === 2000) {
          return { result: true };
        } else {
          return { result: false, error: response.scResponse?.message };
        }
      }
    } catch (error) {
      return {
        result: false,
        error: "There was an error performing the operation",
      };
    }

    return {
      result: true,
      error: "There was an error performing the operation",
    };
  }
}
